import UserDropdownIcon from '@/shared/ui/icons/UserDropdownIcon';
import { Skeleton } from '@/shared/ui/skeleton';

type ProfileButtonContentProps = {
	isLoading: boolean;
	isError: boolean;
	initials: string;
	fullName?: string;
	companyName?: string | null;
};

const ProfileButtonContent = ({
	isLoading,
	isError,
	initials,
	fullName,
	companyName,
}: ProfileButtonContentProps) => {
	if (isLoading) {
		return (
			<div className='flex items-center gap-3'>
				<Skeleton
					circle
					width={32}
					height={32}
				/>
				<div className='flex flex-col'>
					<Skeleton
						width={100}
						height={12}
						borderRadius={4}
					/>
					<Skeleton
						width={72}
						height={10}
						borderRadius={4}
					/>
				</div>
			</div>
		);
	}

	if (isError) {
		return (
			<div className='flex items-center gap-3'>
				<div className='h-8 w-8 flex items-center justify-center bg-secondary text-inverse rounded-full'>
					<UserDropdownIcon
						width={16}
						height={16}
					/>
				</div>
			</div>
		);
	}

	return (
		<div className='flex items-center gap-3'>
			<div className='h-8 w-8 flex items-center justify-center bg-primary text-inverse rounded-full'>
				<span>{initials}</span>
			</div>
			<div className='flex flex-col items-start gap-1'>
				<h3 className='text-primary font-sans font-medium text-base leading-none tracking-normal'>
					{fullName}
				</h3>
				<span className='text-tertiary font-sans font-medium text-xs leading-none tracking-normal'>
					{companyName}
				</span>
			</div>
		</div>
	);
};

export default ProfileButtonContent;
